import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    motorBodyTypes: [],
    motorBodyType: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const motorBodyTypeSlice = createSlice({
    name: "motorBodyType",
    initialState,
    reducers: {
        setMotorBodyTypes: (state, action) => {
            state.motorBodyTypes = action.payload;
        },
        setMotorBodyType: (state, action) => {
            state.motorBodyType = action.payload;
        },
        setCurrentPage: (state, action) => {
            console.log('action.payload',action.payload);
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
})
console.log('motorBodyTypeSlice',motorBodyTypeSlice);

export const { setMotorBodyTypes, setMotorBodyType, setCurrentPage, setTotalPages, setRowsPerPage } = motorBodyTypeSlice.actions;
export default motorBodyTypeSlice.reducer;